import React from "react";
import { useSelector } from "react-redux";

export default function LogoNavbar(props) {
  const collapseSidebar = useSelector(
    (state) => state.collapseSidebarReducer.collapseSidebar
  );
  
  return (
    <div
    className={
      collapseSidebar
        ? props.company?.logo_mini
          ? "logo-container-collapse left-margin"
          : "logo-container-collapse-small"
        : "logo-container"
    }
  >
    {props.company && (
      <img
        src={
          collapseSidebar
            ? props.company?.logo_mini || props.company.logo
            : props.company.logo
        }
        alt="Company logo image"
      />
    )}
  </div>
  );
}